import React from 'react';
import { injectTestId } from '@cvent/nucleus-test-automation';
import { Col } from '@cvent/carina/components/Col';
import { Row } from '@cvent/carina/components/Row';
import NavigationMenu, { NavigationMenuProps } from './NavigationMenu';

interface Props {
  flyoutControls: React.ReactNode[];
  navMenuProps: NavigationMenuProps;
}

/**
 * TODO: This navigation flyouts component file should use a
 * collection of icons that should be rendered for desktops
 */
function NavigationFlyouts({ flyoutControls, navMenuProps }: Props): JSX.Element {
  return (
    <Col
      {...injectTestId('navigation-flyouts')}
      padding={0}
      flex={{ display: 'flex', alignItems: 'center' }}
      width="content"
    >
      <div>
        <Row>
          {flyoutControls.map((flyout, index) => (
            <Col
              key={index}
              flex={{ display: 'flex', alignItems: 'center' }}
              width="content"
              padding={{ start: index > 0 ? 2 : 0, end: 0 }}
            >
              {flyout}
            </Col>
          ))}
          <Col
            padding={{ start: 2, end: 24 }} // if the end padding is changed also update in useNavFlyoutPlacement
            flex={{ display: 'flex', alignItems: 'center' }}
            width="content"
          >
            <NavigationMenu {...navMenuProps} />
          </Col>
        </Row>
      </div>
    </Col>
  );
}

export default NavigationFlyouts;
